import React, { useState } from 'react';
import './AddPinView.less';
import NavigationBar from '../../../components/NavigationBar/NavigationBar';
import { isLocalizeAdded, LocalizePropType } from 'getaway-data-layer';
import { GA_TITLES, isDashboardScreen } from '../../../../utils';
import { TextField } from '@mui/material';
import ListItem from '../../../components/ListItem/ListItem';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import BrandButton from '../../../components/BrandButton/BrandButton';

type Props = {
  localize: LocalizePropType;
  onClose: () => void;
  onSubmit: (pin: string) => void;
};

const AddPinView = ({ localize, onClose, onSubmit }: Props) => {
  const [pin, setPin] = useState('');

  const processInput = (e: any) => {
    const num = e.target.value;
    if (/[^0-9]/.test(num)) return;
    if (num?.length === 4) {
      e.clipboardData = {
        getData: () => num.trim(),
      };
      onPaste(e);
    } else {
      if (num?.length <= 4) {
        setPin(num);
      }
    }
  };

  const onPaste = (e: any) => {
    const num = e?.clipboardData?.getData('text');
    if (/^\d+$/.test(num) && num?.length === 4) {
      setPin(num);
    }
  };

  return (
    <div className="screen-container">
      <NavigationBar
        TitleTestId="AddPinView-title"
        DescriptionTestId="AddPinView-description"
        title={localize('wj.pin.title')}
        description={localize('wj.pin.desc')}
        showHelp
        showArrowBack={isDashboardScreen()}
        onClose={onClose}
      />
      <div
        className={
          isLocalizeAdded(localize, 'pin.faq')
            ? 'screen-body-faq'
            : 'screen-body'
        }
      >
        <div
          className={
            isLocalizeAdded(localize, 'pin.faq')
              ? 'screen-body-content-faq'
              : 'screen-body-content'
          }
        >
          <div>
            <div className="account-header" style={{ marginTop: 0 }}>
              {localize('pin.header')}
            </div>
          </div>
          <div className="code-input">
            <TextField
              id="otp"
              sx={{ width: 1 }}
              label={localize('wj.pin.placeholder')}
              variant="standard"
              size="small"
              type="number"
              value={pin}
              inputProps={{
                'data-testid': 'AddPinView-otp',
                pattern: '[0-9]*',
                inputMode: 'numeric',
                maxLength: 4,
              }}
              name="one-time-code"
              autoComplete="one-time-code"
              onChange={(e) => processInput(e)}
              onPaste={(e) => onPaste(e)}
            />
          </div>
          <div>
            <div className="addPin-footnote-text">
              <Markdown rehypePlugins={[rehypeRaw]}>
                {localize('pin.footnote.md')}
              </Markdown>
            </div>
          </div>
          <BrandButton
            id={GA_TITLES.ON_BOARDING.ADD_DL}
            title={localize('pin.button')}
            onClick={() => onSubmit(pin)}
            disabled={pin?.length < 4}
          />
        </div>
        {isLocalizeAdded(localize, 'pin.faq') && (
          <div className="faq">
            <Markdown rehypePlugins={[rehypeRaw]}>
              {localize('pin.faq')}
            </Markdown>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddPinView;
